import './MaintenancePage.scss';
import maintenanceVector from '../../../assets/images/maintenance.svg';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { observer } from "mobx-react";
import { useTranslation } from "../../../platform/stores/translationStore";

export const MaintenancePage = observer(() => {
  const [searchParams] = useSearchParams();
  const [days, setDays] = useState('00');
  const [hours, setHours] = useState('00');
  const [minutes, setMinutes] = useState('00');
  const [seconds, setSeconds] = useState('00');
  const t = useTranslation();

  useEffect(() => {
    const end = searchParams.get('end');
    if (!end)
      return;

    const eventDate = new Date(end);
    const countDown = eventDate.getTime();
    const dis = countDown - new Date().getTime();
    if (dis <= 0)
      return;

    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDown - now;
      setDays(getTrueNumber(Math.floor(distance / day)));
      setHours(getTrueNumber(Math.floor((distance % day) / (hour))));
      setMinutes(getTrueNumber(Math.floor((distance % hour) / (minute))));
      setSeconds(getTrueNumber(Math.floor((distance % minute) / second)));

      if (distance < 0) {
        clearInterval(interval);
      }
    }, 0);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const getTrueNumber = (number: number) => {
    if (number < 10) return '0' + number;
    return number.toString();
  }

  return (
    <div className="maintenance-page">
      <div className="black-layer">
        <div className="content">
          <div className="content-center">
            <img src={maintenanceVector} alt=""/>
          </div>
          <p>{t('MAINTENANCE_TEXT')}</p>
          <div className="content-center countdown">
            <div className="countdown-item">
              <div className="countdown-item-number">{days}</div>
              <div className="countdown-item-time">{t('MAINTENANCE_DAYS')}</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-item-number">{hours}</div>
              <div className="countdown-item-time">{t('MAINTENANCE_HOURS')}</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-item-number">{minutes}</div>
              <div className="countdown-item-time">{t('MAINTENANCE_MINUTES')}</div>
            </div>
            <div className="countdown-item">
              <div className="countdown-item-number">{seconds}</div>
              <div className="countdown-item-time">{t('MAINTENANCE_SECONDS')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
